import { ref,reactive,computed } from 'vue'
import { useField } from '@/hooks/field'


export function useForm(init={}) {
	const form = reactive({})
	
	for (const [key,value] of Object.entries(init)){
		form[key] = useField(value)
	}

	const withoutValid = k => k !== 'valid'

	form.valid = computed(() => {
		return Object.keys(form).filter(withoutValid).every((key) => form[key].valid)
	});


	

	return form
}

export function useFormat(form) {	
  let newList = {}
  for (const key in form) {
    if(key==='valid') {
      
      continue
    }
    if(key==='phone'){
    	newList[key] = String(form[key].value ?? '').replace(/\D/g, '');
    }else{
    	newList[key] = form[key].value;	
    }  
  }
  return newList
}


export function useTripForm(status) {
	const test = computed(()=>{
		return status
	})
	return test
	// form.status = {id:status.id,name:status.name}

  // if (status==='Назначен исполнитель'){
  //   activeForm.value = 'executor'
  //   form.customer_id = null

  // }else if (status === 'Добавить заказчика'){
  //   activeForm.value = 'customer'
  //   form.status = null
  //   form.executor_id = null

  // }else{
  //   activeForm.value = 'comment'
  //   form.customer_id = null
  //   form.executor_id = null

  // }
  // dialogVisible.value = true

}

export async function touchForm(form) {
  const fields = Object.keys(form)
    .filter((key) => key !== 'valid' && typeof form[key]?.reasign === 'function')
    .map((key) => form[key]);
  fields.forEach((field) => field.blur());
  await Promise.all(fields.map((field) => field.reasign(field.value)));
  return form.valid;
}
